import React from 'react'
import { useInternationalization } from '../../../features/i18n'
import { useViewport } from '../../../utils'
import { excerptTrimmer } from '../../../utils/excerpt-trimmer'

const MAX_TITLE_LENGTH_MOBILE = 45
const MAX_TITLE_LENGTH = 70
const MAX_EXCERPT_LENGTH = 420

const CardFeatured = ({data, embed}) => {
  const { translate, language } = useInternationalization()
  const {
    image,
    date,
    organization,
    title,
    excerpt,
    special
  } = data

  const { isMobile, isTablet } = useViewport()
  const imageHeight = isMobile ? '150px' : isTablet ? '180px' : '260px'
  const imageWidth = isMobile ? '150px' : isTablet ? '180px' : '260px'
  const textColor = embed ? 'text-gray-444' : 'text-white'
  const excerptRendered = excerpt && excerpt[language.name] ? excerpt[language.name] : '-'
  const excerptTrimmed = excerptTrimmer(excerptRendered, MAX_EXCERPT_LENGTH)
  const titleRendered = typeof title === 'string' ? title : title && title[language.name] ? title[language.name] : String(title)
  const titleTrimmed = excerptTrimmer(titleRendered, isMobile ? MAX_TITLE_LENGTH_MOBILE : MAX_TITLE_LENGTH)
  const isPlaceholder = image.toLowerCase().includes('placeholder')

  return (
    <div
      className={`rounded p-3 lg:p-5 flex flex-row`}
      style={{
        boxShadow: `0px 4px ${embed ? '10px' : '20px'} rgba(0, 0, 0, 0.05)`,
        background: embed ? '#fff' : '#448F59'
      }}
      title={titleRendered}
    >
      <div
        className={`bg-no-repeat bg-cover mr-3 lg:mr-5 ${isPlaceholder ? 'bg-left' : 'bg-center'} ${embed ? '' : isMobile || isTablet ? '' : 'mb-4'} lg:mb-0 rounded`}
        style={{height: imageHeight, minWidth: imageWidth, backgroundImage: "url('"+image+"')"}}
      />
      <div>
        <p className={`text-xs lg:text-sm font-bold ${textColor}`}>
          {date}
        </p>
        <p className={`text-xs mb-2 ${embed ? 'text-gray-999' : 'text-white'}`}>
          {organization} /
        </p>
        {
          special &&
          <div className="rounded px-1 text-white text-xs mb-2 inline-block" style={{background: '#FF5448'}}>
            {translate('EVENT', 'special')}
          </div>
        }
        <h3 className={`text-sm lg:text-base ${embed ? '' : 'text-white'} mb-2 font-bold font-primary ${embed ? 'text-sm' : ''} lg:text-2xl`}>
          {titleTrimmed}
        </h3>
        {
          excerpt &&
          <p className={`hidden lg:block text-sm ${textColor}`}>
            {excerptTrimmed}
          </p>
        }
      </div>
    </div>
  )
}

export { CardFeatured }
